import { RightOutlined } from '@ant-design/icons';
import { Modal } from '@bfe/moly';
import { FC } from 'react';

import IconAutoApi from '@/assets/subAccount/icon-auto-api.svg';
import IconSystemApi from '@/assets/subAccount/icon-system-api.svg';
import { useUserProfile } from '@/hooks/useUserProfile';
import { useI18nContext } from '@/i18n/I18n';
import { isMobile } from '@/utils/ua';

import styles from './styles.module.less';

interface IProps {
  visible: boolean;
  onCancel: () => void;
  onCreate: (type: 'system' | 'auto') => void;
}

const SubTitle = () => {
  const [$t] = useI18nContext();
  return (
    <div className={styles.selectTypeModalSubTitle}>
      {$t('demoAccountSelectTypeModalSubTitle')}
    </div>
  );
};

export const SelectApiTypeModal: FC<IProps> = ({
  visible,
  onCancel,
  onCreate,
}) => {
  const [$t] = useI18nContext();
  const { isDemoAccount } = useUserProfile();

  return (
    <Modal
      open={visible}
      title={$t('SelectApiType')}
      onCancel={onCancel}
      width={480}
      zIndex={99999}
      footer={null}
      subTitle={isDemoAccount ? <SubTitle /> : null}
      isMobile={isMobile()}
    >
      <div className={styles.selectTypeModal}>
        <div
          className={styles.item}
          onClick={() => {
            onCreate('system');
          }}
        >
          <span className={styles.itemIcon}>
            <img src={IconSystemApi} alt="" />
          </span>
          <div className={styles.itemTitleWrap}>
            <div className={styles.itemTitle}>{$t('SystemApiType')}</div>
            <div className={styles.itemDesc}>{$t('SystemApiTypeDesc')}</div>
          </div>
          <RightOutlined className={styles.itemArrow} />
        </div>
        <div
          className={styles.item}
          onClick={() => {
            onCreate('auto');
          }}
        >
          <span className={styles.itemIcon}>
            <img src={IconAutoApi} alt="" />
          </span>
          <div className={styles.itemTitleWrap}>
            <div className={styles.itemTitle}>{$t('AutoApiType')}</div>
            <div className={styles.itemDesc}>{$t('AutoApiTypeDesc')}</div>
          </div>
          <RightOutlined className={styles.itemArrow} />
        </div>
      </div>
    </Modal>
  );
};
